const modalActivarCuenta = {
  'Modal Activar Cuenta Subtitulo': 'Activa tu cuenta a través del email que te enviamos',
  'Modal Activar Cuenta Texto': '¿No lo has recibido?',
  'Modal Activar Cuenta Boton Enviar': 'Reenviarme el email',
  'Modal Activar Cuenta Boton Enviado': 'Te hemos reenviado el email de activación',
}

export default modalActivarCuenta
